__turbopack_context__.v({
  "buttonContainer": "ShipmentRow-module__ZGc7ua__buttonContainer",
  "buttonContainerLandscape": "ShipmentRow-module__ZGc7ua__buttonContainerLandscape",
  "imagesContainer": "ShipmentRow-module__ZGc7ua__imagesContainer",
  "itemDetailsContainer": "ShipmentRow-module__ZGc7ua__itemDetailsContainer",
  "itemsInShipment": "ShipmentRow-module__ZGc7ua__itemsInShipment",
  "itemsInShipmentLandscape": "ShipmentRow-module__ZGc7ua__itemsInShipmentLandscape",
  "moreDetailsContainer": "ShipmentRow-module__ZGc7ua__moreDetailsContainer",
  "shipmentContainer": "ShipmentRow-module__ZGc7ua__shipmentContainer",
  "shipmentContainerLandscape": "ShipmentRow-module__ZGc7ua__shipmentContainerLandscape",
  "shipmentItem": "ShipmentRow-module__ZGc7ua__shipmentItem",
  "shipmentItemContainer": "ShipmentRow-module__ZGc7ua__shipmentItemContainer",
  "shipmentStatus": "ShipmentRow-module__ZGc7ua__shipmentStatus",
  "shipmentStatusEddPresent": "ShipmentRow-module__ZGc7ua__shipmentStatusEddPresent",
  "shipmentStatusLandscape": "ShipmentRow-module__ZGc7ua__shipmentStatusLandscape",
});
